import React, { useEffect } from "react";
import FinanceWebinarContent from "../../Components/Webinar/FinanceWebinar";
import "./styles.css";

const FinanceWebinar = () => {
  useEffect(() => {
    // When user lands on this page, set localStorage to prevent the modal from showing
    localStorage.setItem("financeWebinarModalClosed", "true");
  }, []);

  return <FinanceWebinarContent />;
};

export default FinanceWebinar;
